import React from "react";
import { Box, Button } from "@mui/material";
import { motion } from "framer-motion";

type TabType = "contribution" | "draft" | "recentlyVisited";

interface MenuToggleProps {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
  isLoading?: boolean;
  reset: () => void;
}

const tabs: { key: TabType; label: string }[] = [
  { key: "recentlyVisited", label: "Recently Visited" },
  { key: "contribution", label: "My Contributions" },
  { key: "draft", label: "Draft" },

];

const MenuToggle: React.FC<MenuToggleProps> = ({
  activeTab,
  setActiveTab,
  isLoading = false,
  reset,
}) => {
  const activeIndex = tabs.findIndex((t) => t.key === activeTab);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        display: "flex",
        backgroundColor: "#fff",
        borderRadius: "9999px",
        padding: "1.5%",
        marginBottom: 2,
        overflow: "hidden",
        boxShadow: "0px 10px 10px 0px #F9B4FF33",
      }}
    >
      {/* Sliding Background */}
      <motion.div
        layout
        transition={{ type: "spring", stiffness: 280, damping: 26 }}
        style={{
          position: "absolute",
          top: 6,
          bottom: 6,
          left: `calc(${(activeIndex / 3) * 100}% + 6px)`,
          width: "calc(33.333% - 12px)",
          borderRadius: "9999px",
          background: "linear-gradient(180deg, #9D79F4 0%, #7747FB 100%)",
          boxShadow: "0 4px 12px rgba(119, 71, 251, 0.4)",
        }}
      />

      {tabs.map((tab) => (
        <Button
          key={tab.key}
          disableRipple
          onClick={() => {
            if (isLoading) return;
            setActiveTab(tab.key);
            reset();
          }}
          sx={{
            flex: 1,
            borderRadius: "9999px",
            fontWeight: 600,
            fontSize: { xs: "2.8vw", sm: 12 },
            textTransform: "none",
            color: activeTab === tab.key ? "#fff" : "#8C8C8C",
            transition: "color 0.3s ease",
            zIndex: 1,
            py: 0.9,
            px: 0.5,
            minWidth: 0,
          }}
        >
          {tab.label}
        </Button>
      ))}
    </Box>
  );
};

export default MenuToggle;
